import * as React from 'react'
import Error from 'theme/atoms/Error'
import * as Sentry from '@sentry/gatsby'

export class ErrorBoundary extends React.Component<
  { children: any; accountProviderBoundary?: boolean },
  { hasError: boolean }
> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error, errorInfo)
    
    // Sentry Logging mit relevanten Kontextinformationen
    Sentry.withScope((scope) => {
      const pathname =
        typeof window !== 'undefined' ? window.location.pathname : undefined
      const url =
        typeof window !== 'undefined' ? window.location.href : undefined
      const isCheckout = pathname ? /checkout/.test(pathname) : false
      scope.setTag(
        'boundary',
        this.props.accountProviderBoundary ? 'accountProvider' : 'global'
      )
      scope.setTag('isCheckout', String(isCheckout))
      if (pathname) scope.setTag('path', pathname)
      if (typeof navigator !== 'undefined') {
        scope.setContext('client', {
          userAgent: navigator.userAgent,
          language: navigator.language,
          platform: navigator.platform
        })
      }
      scope.setContext('errorInfo', {
        componentStack: errorInfo?.componentStack || 'n/a'
      })
      scope.setContext('location', {
        href: url,
        pathname
      })
      scope.setFingerprint(['ErrorBoundary', pathname || 'unknown', error.name])
      scope.setLevel('error')
      Sentry.captureException(error)
    })
  }

  componentDidUpdate(previousProps) {
    if (previousProps.children !== this.props.children)
      this.setState({ hasError: false })
  }

  render() {
    if (
      typeof window !== 'undefined' &&
      window.location.pathname === '/error/' &&
      this.state.hasError
    ) {
      return <h1>Something went super wrong</h1>
    }

    if (this.state.hasError) {
      const isCheckout = /checkout/.exec(window.location.pathname)
      if (isCheckout) {
        return <Error location={window.location} checkoutLayout />
      } else {
        return this.props.accountProviderBoundary ? (
          <Error location={window.location} renderWithoutCart />
        ) : (
          <Error location={window.location} />
        )
      }
    }
    return this.props.children
  }
}
